import React from "react";
import PropTypes from "prop-types";

const ReviewHSContent = ({ fitFeedbackMap }) => {
  const fitFeedBack = Object.keys(fitFeedbackMap).map(key => {
    return (
      <div className="fit-feedback-map__each" data-test-id="fit-feedback-map__each" key={key}>
        <p className="fit-feedback-map__each__head">{key}</p>
        <p className="fit-feedback-map__each__child">{fitFeedbackMap?.[key] || ""}</p>
      </div>
    );
  });

  return (
    <div className="inline-block fit-feedback-map" data-test-id="fit-feedback-map">
      {fitFeedBack}
    </div>
  );
};

ReviewHSContent.propTypes = {
  fitFeedbackMap: PropTypes.object.isRequired,
};

export default ReviewHSContent;
